const TextStrings = {
    'CRIAR_CONTA_GIRO': 'Criar uma conta no Giro',
    'RECUPECAO_SENHA_GIRO': 'Recuperação de senha do Giro',
    'INGLES':'English',
    'PORTUGUES':'Portuguese',
    'RECUPERAR': 'recuperar',
    'CRIAR_CONTA': 'criar conta',
    'ESQUECI_MINHA_SENHA': 'esqueci minha senha',
    'ENTRAR_COM_GOOGLE': 'entrar com google',
    'OU': 'ou',
    'CONFIRMAR': 'confirmar',
    'CONTINUAR': 'continuar',
    'TERMOS_CONDICOES': 'Termos e declaração de uso',
    'TERMOS_DE_USO': 'Termos e condições de uso',
    'ACOMPANHAR_PEDIDO': 'Para acompanhar o andamento do seu pedido retorne ao aplicativo do Giro - Metrô Rio',
    'DECLARACAO_PRIVACIDADE': 'Declaração de privacidade',
    'FECHAR': 'fechar',
    'COPYRIGHT': `\u00A9 Copyright MetroRio {0}. Todos os direitos reservados.`,
    'RECARGA_NAO_EFETUADA': '"Recarga não efetuada"',
    'RECARGA': 'recarga',
    'VANTAGENS': 'vantagens',
    'EXTRATO': 'extrato',
    'MEUS_DADOS': 'meus dados',
    'AJUDA': 'ajuda',
    'SAIR': 'sair',
    'MENSAGEM': 'mensagem',
    'ELOGIO': 'elogio',
    'CRITICA': 'crítica',
    'INFORMACAO': 'informação',
    'SUGESTAO': 'sugestão',
    'ASSUNTO': 'assunto',
    'ESCOLHA_POR_CATEGORIA': 'Escolha por categoria',
    'DESTAQUE': 'Destaque',
    'VOLTAR': 'Voltar',
    'NENHUM_PARCEIRO_CATEGORIA': 'Nenhum parceiro nesta categoria',
    'CARREGANDO': 'Carregando...',
    'IR_PARA_CATEGORIA': 'Ir para categoria',
    'QUERO_SER_INFORMADO_NOVIDADES': 'Quero ser informado de promoções e novidades do MetrôRio por e-mail',
    'BEMVINDO': 'Bem-vindo',
    'BEMVINDO_USUARIO': 'Bem-vindo, {0}!',
    'CARTAO': 'Cartão: {0}',
    'SALDO_NO_CARTAO': 'Saldo no cartão:',
    'SALDO_NO_CARTAO_INFO': 'Saldo disponível para utilização no MetrôRio. Valide créditos pendentes nos terminais de validação das estações.',
    'CREDITOS_PROMOCIONAIS': 'Créditos promocionais:',
    'CREDITOS_PROMOCIONAIS_INFO': 'Crédito promocional disponível para utilização no MetrôRio. O crédito é atualizado após a confirmação de pagamento da recarga.',
    'SALDO_VALIDAR': 'Saldo a validar:',
    'SALDO_VALIDAR_INFO': 'Valide seus créditos diretamente na catraca de qualquer estação do MetrôRio.',
    'PASSAGENS': 'Passagens',
    'ESCOLHA_QTD_PASSAGENS': 'Escolha a quantidade desejada de passagens',
    'INSIRA_VALOR_RECARGA': 'Ou insira o valor da recarga desejada',
    'VALOR_TOTAL': 'Valor Total',
    'CADASTRE_SEU_CUPOM': 'Cadastre seu cupom',
    'NR_PASSAGENS': 'Nº de passagens',
    'FORMA_DE_PAGAMENTO': 'Forma de Pagamento',
    'NO_VALOR_DE': 'No valor de {0}',
    'PAGAMENTO': 'Pagamento',
    'ESCOLHA_SEU_CARTAO': 'Escolha seu cartão',
    'NOVO_CARTAO': 'Novo cartão',
    'RECARREGAR': 'recarregar',
    'VIAGENS': 'Viagens',
    'RECARGA_M': 'Recarga',
    'ENVIAR': 'enviar',
    'MENSAGEM_ENVIADA_SUCESSO': 'Mensagem enviada com sucesso!',
    'AGUARDE': 'aguarde...',
    'BLOQUEAR': 'bloquear',
    'TODOS': 'Todos',
    'DE': 'De',
    'A': 'a',
    'IR': 'ir',
    'DIA': 'Dia',
    'MES': 'Mes',
    'ANO': 'Ano',
    'JANEIRO': 'Janeiro',
    'FEVEREIRO': 'Fevereiro',
    'MARCO': 'Março',
    'ABRIL': 'Abril',
    'MAIO': 'Maio',
    'JUNHO': 'Junho',
    'JULHO': 'Julho',
    'AGOSTO': 'Agosto',
    'SETEMBRO': 'Setembro',
    'OUTUBRO': 'Outubro',
    'NOVEMBRO': 'Novembro',
    'DEZEMBRO': 'Dezembro',
    'DADOS_CADASTRAIS': 'dados cadastrais',
    'ALTERAR_SENHA': 'alterar senha',
    'SENHA_ATUAL': 'senha atual',
    'NOVA_SENHA': 'nova senha',
    'CONFIRMACAO_NOVA_SENHA': 'confirmação da nova senha',
    'CADASTRO_USUARIO': 'Cadastro usuário',
    'NAO_EXISTE_GIRO_ASSOCIADO': 'Não existe cartão Giro vinculado a sua conta.',
    'SEM_HISTORICO_PERIODO': 'Não há histórico para o período selecionado. Altere o filtro acima ou realize uma recarga.',
    'PAGUE_RECEBA_VOLTA': 'Pague e receba de volta',
    'RECARGA_APP': 'Recarga APP - Crédito -',
    'STATUS': 'Status: {0}',
    'EVENTO': 'Evento -',
    'PASSAGEM_UTILIZADA': 'Passagem utilizada - ',
    'ADICIONAR_CARTAO_GIRO': 'adicionar novo cartão Giro',
    'ADICIONAR_CARTAO': 'adicionar novo cartão',
    'GIRO_BLOQUEADO': 'Seu GIRO foi bloqueado com sucesso.',
    'GIRO_BLOQUEADO_TEXTO_1': 'Você possui um saldo de R${0}.',
    'GIRO_BLOQUEADO_TEXTO_2': 'Clique em adicionar novo cartão, para realizar a transferência do saldo',
    'BLOQUEAR_CARTAO_GIRO': 'bloquear cartão Giro',
    'MEU_CARTAO_GIRO': 'meu cartão Giro',
    'PARA_EFETIVAR_TRANSFERENCIA': 'Para efetivar a sua transferência de saldo, precisamos de algumas informações, tire foto dos dados solicitados.',
    'SELECIONE_FOTO_GIRO': 'selecione uma foto do verso do Giro',
    'SELECIONE_FOTO_DOCUMENTO': 'selecione uma foto do seu documento com CPF/Passaporte',
    'DESEJA_BLOQUEAR_GIRO': 'Tem certeza que deseja bloquear o seu Giro?',
    'DESEJA_BLOQUEAR_GIRO_TEXTO_1': 'Esse cartão não poderá ser desbloqueado.',
    'DESEJA_BLOQUEAR_GIRO_TEXTO_2': 'Você pode transferir seu saldo ao cadastrar um novo Giro.',
    'REMOVER': 'remover',
    'MINHA_CARTEIRA': 'minha carteira',
    'DESEJA_REMOVER_CARTAO': 'Deseja mesmo remover o cartão?',
    'DESEJA_REMOVER_CARTAO_INFO': 'Uma vez removido, você poderá adicioná-lo novamente quanto desejar',
    'CARTAO_REMOVIDO': 'Seu cartão foi removido!',
    'ADICIONAR_CARTAO_PAGAMENTO': 'Adicionar cartão de pagamento',
    'REMOVER_ANEXO': 'remover anexo',
    'ENVIAR_ANEXO': 'enviar anexo',
    'VALOR_MAXIMO_RECARGA': 'Valor máximo para recarga é {0}',
    'REAJUSTE_TARIFA': 'REAJUSTE DE TARIFA',
    'REAJUSTE_APARTIR': 'A partir do dia {0}, o valor da passagem será de R{1}',
    'CUPOM_INVALIDO': 'Cupom inválido.',
    'CASHBACK_TOTAL': 'Cashback Total',
    'LIMITE_CASHBACK': 'O limite de cashback deste cupom é de R$ {0}',
    'PERCENTUAL': 'Percentual',
    'CASHBACK_PAG_RECEBA': "Pague e Receba de Volta R$ {0}",
    'CONFIRMAR_RECARGA': 'Confirmar recarga?',
    'CONFIRMAR_COMPRA_BILHETES': 'Confirmar compra dos bilhetes?',
    'LIMITE_TEMPO_PIX': 'Você tem 1 hora para realizar o pagamento antes que o código Pix expire',
    'CADASTRAR_CARTAO': 'cadastrar cartão',
    'DADOS_PESSOAIS': 'dados pessoais',
    'FORM.NOME': 'Nome',
    'FORM.SOBRENOME': 'Sobrenome',
    'FORM.CPF': 'CPF',
    'FORM.PASSAPORTE': 'Passaporte',
    'FORM.TELEFONE': 'Telefone',
    'FORM.DATA_NASCIMENTO': 'Data de Nascimento',
    'FORM.EMAIL': 'e-mail',
    'FORM.SENHA': 'senha',
    'FORM.CONFIRMAR_SENHA': 'confirmação de senha',
    'FORM.CONFIRMAR_EMAIL': 'confirmar e-mail',
    'FORM.NR_GIRO': 'número do Giro',
    'FORM.CONFIRM_NR_GIRO': 'confirmação do número do Giro',
    'ENDERECO': 'endereço',
    'UF': 'UF',
    'CIDADE': 'cidade',
    'NUMERO': 'número',
    'COMPLEMENTO': 'complemento',
    'PEDIDO_RECEBIDO': 'Recebemos seu pedido! Após a aprovação do seu pedido, valide sua recarga online nas nossas estações',
    'FALE_CONOSCO': 'Fale Conosco',
    'NAO_ACHOU_DUVIDA': 'Não encontrou sua dúvida?',
    'NAO_CONCORDO_EXCLUIR_LINK': 'não concordo, quero <a href="/excluir-conta">excluir minha conta</a>',
    'RECEBER_VERIFICACAO_POR': 'Receber o código de verificação de conta por:',
    'VALIDATIONS.ACEITE_REQUIRED': 'Este aceite é obrigatório',
    'FORM.ATUALIZACAO_PAIS': 'Tenho a autorização dos meus responsáveis legais para a realização deste cadastro',
    'FORM.ESTRANGEIRO': 'Sou estrangeiro',
    'EXCLUSAO_CONTA': 'Exclusão de Conta',
    'MOTIVO_EXCLUIR': 'Qual o principal motivo para excluir sua conta no GIRO MetrôRio?',
    'MOTIVO_NAO_USO': 'Não ando mais de metrô',
    'MOTIVO_PROBLEMA': 'Tive um problema com o serviço',
    'MOTIVO_OUTROS': 'Outros',
    'CONTE_MAIS_SAIDA': 'Conta um pouco para a gente sobre o motivo da sua saída?',
    'CARTAO_INSERIDO_SUCESSO': 'Cartão adicionado com sucesso!',
    'CARTAO_INSERIDO_ERRO': 'Erro ao adicionar cartão',
    'LOGIN_ERRO_AUTENTICACAO': 'Erro na Autenticação',
    'GCARD_BLOQUEADO': 'Seu cartão foi bloqueado',
    'ERRO_VALIDAR_GCARD': 'Ops... não foi possivel validar a situação do cartão GIRO {0}',
    'ERRO_CONTATO_GCARD': 'Ocorreu um erro ao entrar em contato com o GIRO {0}',
    'GCARD_TRANSFERENCIA': "Seu Giro foi adicionado com sucesso e seu saldo será transferido em até 5 dias",
    'ERRO_BLOQUEAR_GCARD': 'Não foi possivel bloquear o cartão neste momento, tente novamente {0}',
    'CONTA_EXCLUIDA': 'Sua conta foi excluida',
    'CONTA_EXCLUIDA_MSG': 'Você poderá continuar recarregando e consultando saldo do seu cartão apenas nas estações. Esta exclusão não impede a criação de uma nova conta futuramente.',
    'CONTA_EXCLUIDA_ERRO': "Ocorreu um erro ao tentar excluir sua conta",
    'QRCODE_ERRO_BAIXAR_PDF': 'Não foi possivel baixar o PDF do bilhete: {0}',
    'QRCODE_DISPONIVEL': 'disponível',
    'QRCODE_EXPIRADO': 'expirado',
    'QRCODE_PENDENTE': 'pendente',
    'QRCODE_UTILIZADO': 'utilizado',
    'QRCODE_COMPRA_NAO_REALIZADA': "Compra dos bilhetes não efetuada",
    'TEM_CERTEZA_EXCLUIR': 'Tem certeza que deseja excluir sua conta?',
    'TEM_CERTEZA_EXCLUIR_TEXTO_1': 'Caso prossiga, seus dados pessoais serão excluídos e não poderão ser consultados posteriormente. Você também não poderá mais recarregar ou consultar o saldo de seu cartão através do app ou site Giro MetrôRio, assim como usufruir de ações promocionais vinculadas às recargas digitais.',
    'TEM_CERTEZA_EXCLUIR_TEXTO_2': 'Você poderá continuar recarregando e consultando o saldo do seu cartão apenas nas estações. Esta exclusão não impede a criação de uma nova conta futuramente.',
    'EXCLUIR_CONTA': 'excluir conta',
    'CONTINUAR_RECARREGANDO': 'continuar recarregando aqui',
    'QUERO_RECEBER_PROMOCOES': 'Quero ser informado de promoções e novidades do MetrôRio por e-mail',
    'QRCODE_TITULO': 'Passaporte Réveillon 2026',
    'QRCODE_COMPRAR_BILHETE': '+ comprar',
    'QRCODE_LIMITE': 'Limite de 10 bilhetes por compra.',
    'QRCODE_ORIENTACOES': 'Antes de comprar, acesse  a página da operação Especial de Réveillon para conhecer as regras de embarque.',
    'QRCODE_ACESSAR_BILHETES': 'acessar passaportes comprados',
    'QRCODE_SABER_MAIS': 'saber mais sobre o {0}',
    'QRCODE_ABRIR_BILHETE': 'Toque no QR code para abri-lo',
    'QRCODE_NENHUM_BILHETE_COMPRADO': 'Nenhum bilhete comprado',
    'QRCODE_ESCOLHA_BILHETE': 'Escolha o seu passaporte',
    'QRCODE_ESGOTADO': 'esgotado',
    'QRCODE_NENHUM_BILHETE_DISPONIVEL': 'Nenhum bilhete disponivel para venda',
    'QRCODE_PERMITIDO_BILHETES': 'É permitido apenas a compra de 10 bilhetes por vez',
    'QRCODE_IR_PAGAMENTO': 'ir para o pagamento',
    'QRCODE_BAIXAR_PDF': 'baixar pdf',
    'QRCODE_FORMA_PAGAMENTO':'Escolha a forma de pagamento',
    'QUANTIDADE':'quantidade',
    'QRCODE_SELECIONE_ESTACOES':'Selecione as estações',
    'ORIGEM':'Origem',
    'DESTINO':'Destino',
    'REVISAR_COMPRA':'revisar compra',
    'FINALIZAR_COMPRA':'Finalizar compra',
    'NR_BILHETES':'Nº de bilhetes',
    'QRCODE_VALOR_POR_EMBARQUE':'No valor de {0} por embarque',
    'QRCODE_COMPRA_SOLICITADA':'Compra de bilhetes solicitada',
    'CONFIRMACAO_RECARGA':'Confirmação da recarga',
    'ERROR.RETORNO_SERVIDOR': "Erro no retorno de dados do servidor. Verifique a conexão com a internet.",
    'SENHA_ALTERADA': "Senha Alterada Com Sucesso",
    'VALIDATIONS.FORMA_RECEBER_REQUIRED': 'Selecione uma forma de receber o código de verificação',
    'VALIDATIONS.REQUIRED_FIELD': 'Campo obrigatório',
    'VALIDATIONS.GIRO_INVALIDO': 'O valor não confere com o campo número do Giro',
    'VALIDATIONS.EMAIL_REQUIRED': 'E-mail é Obrigatório',
    'VALIDATIONS.EMAIL_INVALID': 'E-mail inválido',
    'VALIDATIONS.USERNAME_REQUIRED': 'Username é Obrigatório',
    'VALIDATIONS.CPF_INVALID': 'Este CPF é inválido',
    'VALIDATIONS.SENHA_REQUIRED': 'Senha é Obrigatória',
    'VALIDATIONS.SENHA_RULES': 'A senha deve ter no mínimo 8 caracteres, números e uma letra maiúscula',
    'VALIDATIONS.RECARGA_CARTAO_OBRIGATORIO': 'Para efetuar recargas, você precisa cadastrar um cartão de pagamento. Vá até a tela de meus dados.',
    'VALIDATIONS.RECARGA_GIRO_OBRIGATORIO': 'Para fazer uma recarga, por favor cadastre um cartão Giro. Vá até a tela de meus dados.',
    'VALIDATIONS.SEM_PRECO_PASSAGEM': 'Sem preço passagem',
    'VALIDATIONS.ESCOLHA_CARTAO_PAGAMENTO': 'Escolha um cartão de pagamento',
    'VALIDATIONS.SELECIONE_QTD_PASSAGENS': 'Selecione uma quantidade de passagens ou o valor da Recarga',
    'VALIDATIONS.CONFIRM_SENHA_INVALID': 'O valor não confere com o campo senha',
    'VALIDATIONS.CONFIRM_EMAIL_INVALID': 'O valor não confere com o campo e-mail',
    'VALIDATIONS.MOTIVO_REQUIRED': 'É necessário preenchimento do motivo principal para continuar.',
    'VALIDATIONS.TERMOS_REQUIRED': 'Para prosseguir é necessário aceitar os termos e a declaração de privacidade',
    'VALIDATIONS.FORMAT_DATA': 'A data deve ser digitada no formato: dd/mm/aaaa',
    'VALIDATIONS.NAO_PODE_MENOR': 'Não é possivel criar um cadastro com menos de 16 anos',
}

export default TextStrings;